import React from 'react';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';
import { PolicyPage } from '../styles/policyStyles';
import { useLanguage } from '../context/LanguageContext';
import TermsEn from '../content/legal/TermsEn';
import TermsZh from '../content/legal/TermsZh';

function TermsPage() {
  const { language } = useLanguage();
  const Content = language === 'zh' ? TermsZh : TermsEn;

  return (
    <>
      <SiteHeader />
      <PolicyPage>
        <Content />
      </PolicyPage>
      <SiteFooter />
    </>
  );
}

export default TermsPage;
